// extracted by mini-css-extract-plugin
export default {"container":"search_modal-module__container--17w5u","scrollParentContainer":"search_modal-module__scrollParentContainer--3iKHI"};